export default __webpack_public_path__ + "static/media/default-avatar.d5d2be34.svg";